import { RenderIf } from 'components/RenderIf'
import { InstructionsBlock } from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

export const QRMInstructions = () => {
  const t = useTranslations()
  const { selfService } = useMySelector((state) => state.app.menu)

  return (
    <RenderIf
      condition={process.env.REACT_APP_IS_CLIC === '0' && selfService === 1}
    >
      <InstructionsBlock>
        <p>1. {t('mainPage.orderAndPay')}</p>
        <p>2. {t('mainPage.smsRecieve')}</p>
        <p>3. {t('mainPage.counter')}</p>
      </InstructionsBlock>
    </RenderIf>
  )
}
